import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=197ae319&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=197ae319&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ae319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197ae319')) {
      api.createRecord('197ae319', component.options)
    } else {
      api.reload('197ae319', component.options)
    }
    module.hot.accept("./UploadImg.vue?vue&type=template&id=197ae319&scoped=true&", function () {
      api.rerender('197ae319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/UploadImg.vue"
export default component.exports